export default __webpack_public_path__ + "static/media/github-logo.ad40658e.png";